import { render } from "./PieCTA.vue?vue&type=template&id=9bfccb44&scoped=true"
import script from "./PieCTA.vue?vue&type=script&lang=js"
export * from "./PieCTA.vue?vue&type=script&lang=js"

import "./PieCTA.vue?vue&type=style&index=0&id=9bfccb44&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfccb44"]])

export default __exports__